<!-- フッター -->
<template>
  <footer class="crly-o-common-footer">
    <CMS contents_type="block_contents" location_code="CRLY_TOP_99_01-footer" />
  </footer>
</template>

<script>
import CMS from "@/components/CMS";

export default {
  name: "CrlyOrganismsCommonFooter",
  components: { CMS }
};
</script>

<style lang="scss" scoped></style>
